import StyledInput from 'components/styledInput/StyledInput';
import { useState } from 'react';

// A text written in place (a task's description, an appointment's report):
// it is saved when the field is left, if it changed. `onSave` says whether
// it was. A disabled one is only read.
const AutosaveTextarea = ({ label, placeholder, initial, onSave, isDisabled = false }) => {
  const [value, setValue] = useState(initial);
  const [saved, setSaved] = useState(initial);
  const save = async () => {
    if (isDisabled || value.trim() === saved.trim()) return;
    if (await onSave(value.trim())) setSaved(value);
  };
  return (
    <div onBlur={save}>
      <StyledInput
        type="textarea"
        label={label}
        placeholder={placeholder}
        value={value}
        maxLength={2000}
        isDisabled={isDisabled}
        onChange={(event) => setValue(event.target.value)}
      />
    </div>
  );
};

export default AutosaveTextarea;
